module.exports = __webpack_public_path__ + "media/images/common/nav_reserved-d8cf97bbff781b5bdef0484efc6b6b07.gif";